import React from 'react'
import { Container, Row, Col } from 'reactstrap'

const Main = () => (
  <Container className="page">
    <Row>
      <Col><h2>Main Private</h2></Col>
    </Row>
  </Container>
)

export default Main
